module.exports = __webpack_public_path__ + "static/img/daily-cash-bg.d2a4520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/daily-cash-bg.png
// module id = 7x+E
// module chunks = 216